var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-success my-1 px-2 py-1",attrs:{"role":"alert"}},[_vm._v(" Успешно! Ваше имя пользователя и пароль отправлены вам в смс. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }